//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './EmailSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export function emailSettingsGetUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/emailing";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let emailSettingsGetDefaultOptions: Omit<UseQueryOptions<Types.EmailSettingsDto, unknown, Types.EmailSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.EmailSettingsDto, unknown, Types.EmailSettingsDto>, 'queryFn'>> = {
};
export function getEmailSettingsGetDefaultOptions() {
  return emailSettingsGetDefaultOptions;
};
export function setEmailSettingsGetDefaultOptions(options: typeof emailSettingsGetDefaultOptions) {
  emailSettingsGetDefaultOptions = options;
}

export function emailSettingsGetQueryKey(): QueryKey;
export function emailSettingsGetQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'EmailSettingsClient',
      'emailSettingsGet',
    ]);
}
export function __emailSettingsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.emailSettingsGet(
axiosConfig    );
}

/**
 * @return OK
 */
export function useEmailSettingsGetQuery<TSelectData = Types.EmailSettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.EmailSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useEmailSettingsGetQuery<TSelectData = Types.EmailSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.EmailSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.EmailSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __emailSettingsGet(context, axiosConfig) : __emailSettingsGet,
    queryKey: emailSettingsGetQueryKey(),
    ...emailSettingsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.EmailSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setEmailSettingsGetData(queryClient: QueryClient, updater: (data: Types.EmailSettingsDto | undefined) => Types.EmailSettingsDto, ) {
  queryClient.setQueryData(emailSettingsGetQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setEmailSettingsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.EmailSettingsDto | undefined) => Types.EmailSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function emailSettingsUpdateUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/emailing";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function emailSettingsUpdateMutationKey(): MutationKey {
  return trimArrayEnd([
      'EmailSettingsClient',
      'emailSettingsUpdate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useEmailSettingsUpdateMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.UpdateEmailSettingsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateEmailSettingsDto, TContext> {
  const key = emailSettingsUpdateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdateEmailSettingsDto) => Client.emailSettingsUpdate(body),
    mutationKey: key,
  });
}
  
export function emailSettingsSendTestEmailUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/emailing/send-test-email";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function emailSettingsSendTestEmailMutationKey(): MutationKey {
  return trimArrayEnd([
      'EmailSettingsClient',
      'emailSettingsSendTestEmail',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useEmailSettingsSendTestEmailMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.SendTestEmailInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendTestEmailInput, TContext> {
  const key = emailSettingsSendTestEmailMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SendTestEmailInput) => Client.emailSettingsSendTestEmail(body),
    mutationKey: key,
  });
}